export default __webpack_public_path__ + "static/media/person_2.a9a9320f.png";